
import React from "react";
import { useAuth } from '../../../hooks/useAuth';
import Dialog from "../Dialog/Dialog";
import { clearStoredTokens } from '../../../services/config/axios.config';

const SessionTimeoutDialog: React.FC = () => {
  const { showTimeoutDialog, setShowTimeoutDialog, logout } = useAuth();

  const handleClose = () => {
    // Eliminar tokens de sesión y refresh token
    clearStoredTokens();
    setShowTimeoutDialog(false);
    logout();
  };

  return (
    <Dialog
      open={showTimeoutDialog}
      onClose={() => {}}
      title="Sesión cerrada por inactividad"
      message="Por seguridad, tu sesión ha expirado debido a inactividad."
      confirmText="Iniciar sesión"
      onConfirm={handleClose}
    />
  );
};

export default SessionTimeoutDialog;
